"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var context_1 = require("../context");
// Helper hook that uses a ref to store an array, and only changes the
// value when a shallow compare fails
function useMemoizedArray(arr) {
    var ref = React.useRef(arr);
    if (arr.length !== ref.current.length || arr.some(function (e, i) { return ref.current[i] !== e; })) {
        ref.current = arr;
    }
    return ref.current;
}
function buildPredicate(selection, filters) {
    return filters.reduce(function (acc, filter) {
        var predicate = filter(selection);
        return function (obj) { return acc(obj) && predicate(obj); };
    }, (function () { return true; }));
}
function useClientFilters(data, filters) {
    var selection = context_1.useListingContext().filtering.selection;
    var predicate = React.useCallback(buildPredicate(selection, filters), [selection, useMemoizedArray(filters)]);
    return React.useMemo(function () { return data.filter(predicate); }, [predicate, data]);
}
exports.default = useClientFilters;
//# sourceMappingURL=useClientFiltering.js.map